import { useTranslation } from 'react-i18next';

interface OrderSuccessModalProps {
  isOpen: boolean;
  orderId: string;
  onClose: () => void;
  onGoToDashboard: () => void;
}

const OrderSuccessModal = ({
  isOpen,
  orderId,
  onClose,
  onGoToDashboard,
}: OrderSuccessModalProps) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="order-success-title"
    >
      <div className="w-full max-w-md rounded-2xl border border-orange-100 bg-white p-6 shadow-2xl">
        <h2 id="order-success-title" className="text-2xl font-semibold text-orange-700">
          {t('checkout.successTitle')}
        </h2>
        <p className="mt-3 text-sm text-slate-600">{t('checkout.successMessage')}</p>
        <p className="mt-2 text-sm font-semibold text-orange-700">
          {t('dashboard.orderIdLabel')}: {orderId}
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={onGoToDashboard}
            className="rounded-xl bg-orange-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-orange-600"
          >
            {t('checkout.goToDashboard')}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-orange-200 px-4 py-2 text-sm font-semibold text-orange-600 transition hover:border-orange-300 hover:text-orange-700"
          >
            {t('common.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessModal;
